import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import OptionImage from "@components/OptionImage";
import next from "../../assets/images/next@2x.png";
import  { ReactComponent as Close_circle}  from "../../assets/images/close-circle-line.svg";
import timer_bg from "../../assets/images/timer_bg.png";
import {submitAnswer} from '../../service/index.js'
import { useTimer ,useWindowWidth} from "@hooks/index";
import Modal from 'react-modal'
import "./index.scss";
const duration = 8
const Quiz = ({question,onQuizChange,onChangeStep}) => {
  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const {timeLeft, resetTimer, pauseTimer, formattedTime } = useTimer(duration);
  const [hasAnswered, setHasAnswered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [quizData,setQuizData] = useState({})
  const [nextQuizData,setNextQuizData] = useState({})
  const [isCorrect,setIsCorrect] = useState(false)
  const [questionIndex,setQuestionIndex] = useState(0)

  // const windowWidth = useWindowWidth()
  useEffect(()=>{
    setQuizData(question)
  },[question])
  const postSubmitAnswer = async (isCorrect) => {
    try{
      const aiOrNot =JSON.parse(localStorage.getItem('aiOrNot'));
      console.log(aiOrNot)
      const res = await submitAnswer({
        method: "POST",
        body: JSON.stringify({
          "session_id": aiOrNot.session_id || '',
          "game_number": aiOrNot.game_number || '',
          "question_id": quizData.id,
          "is_correct": isCorrect
        }),
        headers: {
          "content-type": "application/json",
        },
      }).then((res) => res);
      const data = await res.json()
      if(res.status== 200){
        setQuestionIndex(pre=> pre+1)
        // localStorage.setItem('aiOrNot',JSON.stringify({session_id:data.session_id,game_number:data.game_number}))
        if(data.next_question){
          setNextQuizData(data.next_question);
        }else{
          setNextQuizData('')
        }
      }
    }catch(err){
      console.log(err,'err')
      setHasAnswered(false)
    }

  };
  const getScore = (timeLeft)=>{
    if(timeLeft > 6 ){
      return 10
    }
    if(timeLeft > 4 && timeLeft < 7){
      return 6 
    }
    if(timeLeft > 0 && timeLeft < 5){
      return 3
    }
    return 0
  }
  useEffect(()=>{
    if(!hasAnswered){
      if(timeLeft > 0  && timeLeft <3 ){

      }
      if(timeLeft <= 0 && !hasAnswered){
        setHasAnswered(true);
        setIsVisible(true);
        setScore(0)
        setIsCorrect(false);
        setTotalScore(pre => Number(pre + 0));
        postSubmitAnswer(false)
      }
    }
   
  },[timeLeft])
  const handleAnswer = async (direction)=>{
    if(hasAnswered) return;
    const _isCorrect = quizData.correct_answer == direction;
    pauseTimer();
    setIsVisible(true);
    if(_isCorrect){
      const _score = getScore(timeLeft);
      setScore(_score)
      setTotalScore(pre => Number(pre + _score));
     
    }else{
      setScore(0)
      setTotalScore(pre => Number(pre + 0));
    }
    setIsCorrect(_isCorrect);
    setHasAnswered(true);
    await postSubmitAnswer(_isCorrect);
  }
  useEffect(()=>{
    onQuizChange && onQuizChange(totalScore)
  },[totalScore])
  const changeModal = ()=>{
    setIsOpen(pre=> !pre);
  }
  const handleNext = ()=>{
    if(questionIndex != 5 && !nextQuizData) return;
    if(!nextQuizData && questionIndex == 5){
      onChangeStep && onChangeStep('result')
    }
    setIsVisible(false);
    if(nextQuizData.introduction){
      setQuizData(nextQuizData)
      setIsCorrect(false)
      setHasAnswered(false)
      setScore(0);
      resetTimer();
      setNextQuizData('');
    }
  }
  const {introduction} = quizData;
  const getScoreStatus = ()=>{
    if (!hasAnswered && timeLeft <= 3) return "quiz_timeout";
    if(hasAnswered && isCorrect){
      return "quiz_success"
    }else{
      return "quiz_error"
    }
    // return timeLeft <= 3
    // ? "quiz_timeout"
    // : isCorrect
    // ? "quiz_success"
    // : "quiz_error";
  }
  const progress = (1-(timeLeft / duration)) * 100;
  return (
    <div className="quiz_wraper">
      <div className="quiz_wraper_title">
        {
           !hasAnswered? <span>Select the <strong>REAL</strong> painting.</span>:null
        }
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={changeModal}
        className="quiz-modal"
      >
        <div className="quiz_modal_close" onClick={changeModal}>
          {/* <img src={close_circle} /> */}
          <Close_circle /> Close
        </div>
        <div className="quiz_modal_content">
          <div className="quiz_modal_title"> {introduction?.name}</div>
          <div className="quiz_modal_img">
            <img
              src={`https://news${process.env.NODE_ENV == 'production'?'':'test'}.cgtn.com/event/2025/ai-or-not/song-painting/images/originals/${
                quizData.correct_answer == "right"
                  ? quizData.image_right_url
                  : quizData.image_left_url
              }.png`}
            />
          </div>
          <div className="quiz_modal_summary">
            <div>
              Author:&nbsp;{introduction?.author}({introduction?.dynasty})
            </div>
            <div>Skill:&nbsp;{introduction?.technique}</div>
            <div>Location: &nbsp;{introduction?.location}</div>
          </div>
        </div>
      </Modal>
      <div className="quiz-container">
        <AnimatePresence>
          {isVisible ? (
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
            >
              <div className={`quiz_score ${getScoreStatus()}`}>
                {" "}
                {score > 0 ? "+ " : ""}
                {score} {`Point${score != 1?'s':''}`}
              </div>
            </motion.div>
          ) : null}
        </AnimatePresence>
        <div className="quiz-images-wraper">
          <OptionImage
            timeLeft={timeLeft}
            title={introduction?.name}
            link={quizData.image_left_url}
            hasAnswered={hasAnswered}
            isCorrect={quizData.correct_answer == "left"}
            onClick={() => handleAnswer("left")}
            onChangeModal={changeModal}
          />
          <OptionImage
            timeLeft={timeLeft}
            title={introduction?.name}
            link={quizData.image_right_url}
            hasAnswered={hasAnswered}
            isCorrect={quizData.correct_answer == "right"}
            onClick={() => handleAnswer("right")}
            onChangeModal={changeModal}
          />
        </div>
        {
          hasAnswered ?<div className="quiz-next" onClick={handleNext}>
            <div>Next</div>
            <img src={next} />
          </div>:null
        }
        
      </div>
      {
        !hasAnswered?<div className="quiz_timer">
          <motion.div
            className="quiz_timer_inner"
            initial={{ width: "0%" }}
            progress={progress}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.1, ease: "linear" }}
          > 
            <div className="quiz_timer_score">                        
              <img src={timer_bg}/><span style={{marginLeft:"60px",display:'inline-block',marginTop:"20px",width:'84px',overflow:'hidden'}}>{`${getScore(timeLeft)} points` }</span>
            </div>
            <div className="quiz_timer_seconds">{Math.floor(timeLeft)}s</div>
          </motion.div>
        </div>:null
      }
    </div>
  );
};

export default Quiz;
